export function AlbertaHero() {
  return (
    <section className="relative min-h-[600px] flex items-center justify-center bg-white">
      <div className="absolute inset-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/2cc8c5fe8b689c55abfd25227ceb5482.jpg"
          alt="Alberta cities skyline"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>
      
      <div className="relative z-10 max-w-5xl mx-auto px-6 lg:px-12 text-center text-white">
        <h1 className="font-['Fraunces'] text-5xl lg:text-6xl font-bold mb-6 leading-tight">
          Alberta Short-Term Rental Regulations
        </h1>
        <p className="text-xl lg:text-2xl mb-8 leading-relaxed max-w-3xl mx-auto">
          Navigate provincial oversight and city-specific licensing in Edmonton and Calgary with expert compliance management
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a 
            href="#contact"
            className="bg-[#882629] text-white px-8 py-4 rounded-full text-lg font-medium hover:bg-[#6E1F22] transition-all cursor-pointer whitespace-nowrap shadow-lg hover:shadow-xl"
          >
            Get Alberta compliance help
          </a>
          <a 
            href="#provincial-overview"
            className="bg-white/20 backdrop-blur-sm text-white px-8 py-4 rounded-full text-lg font-medium hover:bg-white/30 transition-all cursor-pointer whitespace-nowrap border-2 border-white/50"
          >
            Learn about regulations
          </a>
        </div>
      </div>
    </section>
  );
}
